import { Clock, DollarSign, Target } from "lucide-react";

const features = [
  {
    icon: Clock,
    title: "Save Time",
    description:
      "Our streamlined workflows and expert team handle your design, marketing, and content needs efficiently, allowing businesses to focus on growth while we manage their digital presence.",
  },
  {
    icon: DollarSign,
    title: "Affordable Pricing",
    description:
      "Graphic Lines offers premium quality digital services at competitive and flexible pricing, making professional marketing, branding, and content creation accessible for startups, businesses, and global brands.",
  },
  {
    icon: Target,
    title: "Proven Strategies",
    description:
      "We combine creativity with smart marketing strategies, including branding, ads management, social media marketing, and content creation, helping businesses reach the right audience and achieve measurable growth worldwide.",
  },
];

const FeaturesSection = () => {
  return (
    <section className="py-0 relative">
      <div className="bg-navy rounded-t-[2rem] mx-2 sm:mx-4 lg:mx-8">
        <div className="container mx-auto px-4 py-10 md:py-16">
          <div className="grid sm:grid-cols-2 md:grid-cols-4 gap-8 md:gap-10 items-start">
            <div className="sm:col-span-2 md:col-span-1 text-center md:text-left">
              <h2 className="text-xl sm:text-2xl lg:text-3xl font-bold text-navy-foreground leading-tight">
                Professional Digital Agency
              </h2>
              <p className="text-navy-foreground/70 text-sm mt-3 leading-relaxed">
                At Graphic Lines, we help businesses grow through creative design, professional video editing, and strategic social media marketing.
              </p>
            </div>
            {features.map((f, i) => (
              <div key={i} className="group text-center md:text-left">
                <div className="w-14 h-14 md:w-16 md:h-16 rounded-2xl bg-primary/20 flex items-center justify-center mb-4 md:mb-5 mx-auto md:mx-0 group-hover:bg-primary/30 transition-colors">
                  <f.icon className="w-6 h-6 md:w-7 md:h-7 text-accent" />
                </div>
                <h3 className="text-lg md:text-xl font-bold text-navy-foreground mb-2 md:mb-3">{f.title}</h3>
                <p className="text-sm text-navy-foreground/70 leading-relaxed">{f.description}</p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
